import React from "react";
import { Route, Redirect } from "react-router-dom";

function getSessionMemberAuth() {
  const raw =
    sessionStorage.getItem("auth") ?? sessionStorage.getItem("rank");
  if (raw == null || raw === "") return NaN;
  const n = Number(raw);
  return Number.isFinite(n) ? n : NaN;
}

function isInventorAuth(memberAuth) {
  return (
    Number.isFinite(memberAuth) &&
    window.$Global.checkAuth("특허회사_발명자만", memberAuth)
  );
}

/**
 * @param {boolean} denyInventor - 발명자 전체 차단
 * @param {boolean} denyInventorIfCreate - 발명자가 등록(new) URL로 직접 진입 시 차단
 * @param {string} denyInventorRedirect - 발명자 리다이렉트 경로
 * @param {boolean} requireCompanyManager - 특허회사 관리자만
 */
function UserAuthRoute({
  component: Component,
  requireAuth,
  denyInventor,
  denyInventorIfCreate,
  denyInventorRedirect,
  requireCompanyManager,
  ...parentProps
}) {
  const loggedIn = window.$Global.hasLoginToken();
  const inventorHome = denyInventorRedirect || "/patent/list";

  const renderFunc = (props) => {
    if (requireAuth && !loggedIn) {
      return <Redirect to="/login" />;
    }
    const memberAuth = getSessionMemberAuth();

    if (denyInventor && isInventorAuth(memberAuth)) {
      return <Redirect to={inventorHome} />;
    }

    // /detail/new, /detail/new/dispute 등 등록 URL 직접 접근 차단
    if (denyInventorIfCreate && isInventorAuth(memberAuth)) {
      const params = props.match?.params || {};
      const isCreate =
        params.patent_idx === "new" ||
        params.trademark_idx === "new" ||
        params.design_idx === "new" ||
        params.invention_idx === "new";
      if (isCreate) {
        return <Redirect to={inventorHome} />;
      }
    }

    if (requireCompanyManager) {
      if (
        !Number.isFinite(memberAuth) ||
        !window.$Global.checkAuth("특허회사_관리자", memberAuth)
      ) {
        return <Redirect to="/invention/reviews/evaluations" />;
      }
    }

    return <Component {...props} />;
  };

  if (requireAuth) {
    window.$Global.saveHistory();
  }
  return <Route {...parentProps} render={renderFunc} />;
}

export default UserAuthRoute;
